import AppliedFilters from './AppliedFilters.jsx'
import FilterTemplate from './FilterTemplate.jsx'
import FiltersAccordion from './FiltersAccordion.jsx'
import FiltersBtn from './FiltersBtn.jsx'
import FiltersContainer from './FiltersContainer.jsx'
import React from 'react'
import ReactDOM from 'react-dom'
import Search from './Search.jsx'
import useDidMountEffect from '../../../utils/useDidMountEffect.js'
import { generateFilterrificQuery } from '../../../utils/query.js'

/**
 * Container for the body of the ns_data index body.
 */
const FilterContainer = ({ props }) => {
  /**
   * State management of this component
   * TODO: Break out into reducers when complexity grows
   */
  const allPossibleFilters = props.filtersList
  const [expanded, setExpanded] = React.useState(false)
  const [unusedFiltersList, setUnusedFiltersList] = React.useState(allPossibleFilters)
  const [appliedFilters, setAppliedFilters] = React.useState([])
  const [search, setSearch] = React.useState('')

  /**
   * Helper functions
   */
  const isSearchable = (searchableAttributes) => Array.isArray(searchableAttributes) && searchableAttributes.length > 0
  const isFilterable = (filtersList) => filtersList.length > 0
  const showFiltersContainer = ({ searchableAttributes, filtersList }) => isSearchable(searchableAttributes) || isFilterable(filtersList)
  const hasAppliedFilters = filters => filters.length > 0
  const handleChange = () => setExpanded(!expanded)
  const handleSearchInput = ({ target: { value } }) => setSearch(value)

  /**
   * Add new filter to list of applied and trigger refetch and
   * remove the filter from the list of avaialable filters that
   * can be selected.
   */
  const addToAppliedFilters = (filterToAdd) => {
    filterToAdd.id = Math.floor(Math.random() * 100000)
    const newApplied = [...appliedFilters, filterToAdd]
    setAppliedFilters(newApplied)
    setUnusedFiltersList(allPossibleFilters)
  }

  /**
   * Remove an applied filter, refetch data and make the filter avaialable to
   * be selected again.
   */
  const appliedFilterRemoved = (id) => {
    return () => {
      setAppliedFilters(appliedFilters.filter(af => af.id !== id))
    }
  }

  /**
   * Apply changes to predicate or values of applied filters and refetch data
   */
  const appliedFilterChanged = (changes) => {
    const res = appliedFilters
      .map((applied) => {
        if (applied.selectedColumn.ni_table_attribute === changes.selectedColumn.ni_table_attribute && changes.selectedValues.id === applied.id) {
          applied = { ...applied, ...changes }
        }
        return applied
      })

    setAppliedFilters(res)
  }

  /*
   * When a filter is changed refetch data automatically.
   */
  useDidMountEffect(() => {
    const queryString = generateFilterrificQuery(appliedFilters, search)

    fetch(`${props.baseUrl}?${queryString}`, { headers: { Accept: 'text/vnd.turbo-stream.html' } })
      .then(res => res.text())
      // eslint-disable-next-line no-undef
      .then(html => Turbo.renderStreamMessage(html))
  }, [appliedFilters, search])

  return (
    <div>
      {showFiltersContainer(props) &&
        <FiltersContainer>
          {isSearchable(props.searchableAttributes) &&
            <Search
              handleSearchInput={handleSearchInput}
            />}
          {isFilterable(props.filtersList) && <FiltersBtn handleClick={handleChange} />}
          <FiltersAccordion expanded={expanded}>
            <FilterTemplate addToAppliedFilters={addToAppliedFilters} filtersList={unusedFiltersList} />
            {
              hasAppliedFilters(appliedFilters) &&
                <AppliedFilters
                  filtersList={allPossibleFilters}
                  appliedList={appliedFilters}
                  filterChanged={appliedFilterChanged}
                  filterRemoved={appliedFilterRemoved}
                />
            }
          </FiltersAccordion>
        </FiltersContainer>}
    </div>
  )
}

const Init = () => {
  [...document.getElementsByTagName('filters-container')].forEach(el => {
    const displayName = el.getAttribute('props-display-name')
    const baseUrl = el.getAttribute('props-base-url')
    const searchableAttributes = JSON.parse(el.getAttribute('props-searchable-attributes'))
    const filtersList = JSON.parse(el.getAttribute('props-filters-list'))
    ReactDOM.render(<FilterContainer props={{ displayName, baseUrl, searchableAttributes, filtersList }} />, el)
  })
}

document.addEventListener('turbo:load', Init)
